import { Switch } from '@thanx/uikit/switch'
import { Text } from '@thanx/uikit/text'
import { BrameCampaign } from 'api/brameCampaigns'
import { buildTranslate } from 'locales'
import React from 'react'
import { Container } from 'react-bootstrap-five'
import GameCollectionContent from './GameCollectionContent'

const t = buildTranslate('games')

interface GamesEnabledProps {
  activeTab: 'collection' | 'activity'
  onAddGame: () => void
  onEditGame: (game: BrameCampaign) => void
}

const GamesEnabled = ({
  activeTab,
  onAddGame,
  onEditGame,
}: GamesEnabledProps) => {
  return (
    <Container className="pl-0">
      <div className="mt-xl mb-m">
        <Switch condition={activeTab === 'collection'}>
          <GameCollectionContent
            onAddGame={onAddGame}
            onEditGame={onEditGame}
          />
        </Switch>
        <Switch condition={activeTab === 'activity'}>
          <div>
            <Text.Header3>{t('enabled.activity.title')}</Text.Header3>
            <Text.BodyText3 className="mt-s">
              {t('enabled.activity.comingSoon')}
            </Text.BodyText3>
          </div>
        </Switch>
      </div>
    </Container>
  )
}

export default GamesEnabled
